import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgShieldUserFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.979 16.67c-3.075 0-4.082 1.34-4.412 2.228a.28.28 0 0 0 .093.314c2.013 1.576 4.155 2.255 4.195 2.267a.5.5 0 0 0 .29 0c.04-.012 2.167-.686 4.172-2.249a.28.28 0 0 0 .094-.313c-.328-.898-1.336-2.247-4.432-2.247M11.983 8.4a2.1 2.1 0 0 0-2.099 2.1c0 1.159.942 2.1 2.1 2.1a2.101 2.101 0 0 0 0-4.2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.983 14.1a3.604 3.604 0 0 1-3.599-3.6c0-1.985 1.615-3.6 3.6-3.6a3.604 3.604 0 0 1 3.598 3.6c0 1.985-1.615 3.6-3.599 3.6m7.373-8.964C18.651 4.43 13.026 2.5 12 2.5S5.35 4.43 4.644 5.137c-.56.563-.553.996-.509 3.398.018.973.042 2.299.042 4.134 0 2.065.794 3.703 1.867 4.985.136.163.392.126.504-.054.832-1.345 2.529-2.43 5.431-2.43 2.923 0 4.626 1.093 5.457 2.45.11.18.367.218.504.055 1.081-1.285 1.884-2.93 1.884-5.006 0-1.83.024-3.154.042-4.128.043-2.407.051-2.84-.51-3.405"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShieldUserFilled);
export default ForwardRef;
